import bindAll from 'lodash.bindall';
import KeyBy from 'lodash.keyby';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
// import Spinner from '../spinner/spinner.jsx';
import './grid.css';
import ProjectItem from '../containers/project-item.jsx';
import ProjectGridContext from './projectContext';
import {requestMyProjects, requestDeleteProject, requestUpdateProjectTitle} from '../lib/api/work.js';
import {notScratchDesktop} from '../lib/isScratchDesktop.js';
import {Empty} from 'antd';
import {toast} from 'react-hot-toast';
import {compose} from 'redux';
import {connect} from 'react-redux';
import { FileSystem, diff, VersionAction } from "../fs/fs";
import { createHost } from "../fs/host";
import { deployment } from "../deployment";
import { fetchMicroPython } from "../micropython/micropython"
import {message} from 'antd';
import { setProjectNamesList } from '../store/project-state'

const ok = (<FormattedMessage
    defaultMessage="OK"
    description="Menu bar item for my work"
    id="gui.prompt.ok"
/>);

const cancel = (<FormattedMessage
    defaultMessage="Cancel"
    description="Menu bar item for my work"
    id="gui.prompt.cancel"
/>);

const messages = defineMessages({
    networkError: {
        defaultMessage: 'Network error, please check your network connection',
        description: '',
        id: 'gui.alerts.networkConnectionError'
    }
});

class GridComponent extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleClose',
            'handleFilterChange',
            'handleFilterClear',
            'handleMouseEnter',
            'handleMouseLeave',
            'handlePlayingEnd',
            'handleSelect',
            'handleTagClick',
            'setFilteredDataRef',
            'handleConfirm',
            'handleMyProjectsRequest',
            'handleDeleteProject',
            'handleProjectNameUpdateRequest',
            'handleRequestCatch',
            'handleScroll'
        ]);
        this.projectMap = {};
        this.state = {
            playingItem: null,
            filterQuery: '',
            loaded: false,
            projectId: null, // 作品id
            myProjectsData: [],
            current: 1,
            total: 0
        };
        this.bottomRef = React.createRef();
    }

    componentDidMount () {
        // Allow the spinner to display before loading the content
        setTimeout(() => {
            this.setState({loaded: true});
        });
        this.handleMyProjectsRequest('init')
        window.addEventListener('scroll', this.handleScroll, true);
        if (this.props.setStopHandler) {
            this.props.setStopHandler(this.handlePlayingEnd);
        }
    }

    componentDidUpdate (prevProps, prevState) {
        // 这里将array 转正map,方便删除操作
        if (prevState.myProjectsData.length !== this.state.myProjectsData.length) {
            this.projectMap = KeyBy(this.state.myProjectsData, 'id');
        }
        if (prevState.filterQuery !== this.state.filterQuery || prevState.selectedTag !== this.state.selectedTag) {
            this.scrollToTop();
        }
    }

    handleRequestCatch (err) {
        if (err && err.id === 'gui.network.noAccessPermission') {
            // this.props.onUserLoggedOut();
        }
        message.error(err.msg)
        // toast.error(
        //     err.msg || '网络错误'
        //         // this.props.intl.formatMessage({
        //         //     defaultMessage: 'Network error, please check your network connection',
        //         //     id: 'gui.alerts.networkConnectionError'
        //         // })
        // );
        // this.props.onLoadingFinished();
    }
    // 滚动条按需加载数据
    handleScroll () {
        if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight && this.state.total > this.state.myProjectsData.length) {
            this.handleMyProjectsRequest('scrollDown')
        }
    };
    scrollDown() {
        if (this.bottomRef.current) {
          this.bottomRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    handleMyProjectsRequest(type) {
        // 请求原生fs等方法接口
        const logging = deployment.logging;
        const host = createHost(logging);
        const fs = new FileSystem(logging, host, fetchMicroPython);

        if (type === 'init') {
            this.setState({
                myProjectsData: [],
                current: 1
            })
        }
        const { current } = this.state;
        const queryData = {
            current,
            size: 200,
            type: 6
        }
        let nameList = []
        // 发起接口请求，传递 current 参数用于分页
        new Promise((resolve, reject) => {
            this.setState({loaded: false});
            requestMyProjects(resolve, reject, queryData);
        })
        .then(newData => {
            // 将新数据与现有数据合并
            const myData = [...this.state.myProjectsData, ...newData.data.records]
            this.setState({
                loaded: true,
                projectId: null,
                current: current + 1,
                total: newData.data.total,
                myProjectsData: myData
                    .filter(id => {
                        if (notScratchDesktop()) return true; // Do not filter anything in online editor
                        return true;
                    })
                    .map(data => ({
                        rawURL: data.cover || data.rawURL,
                        id: data.id,
                        name: data.title || data.name,
                        featured: true,
                        projectUrl: data.sourceUrl || data.projectUrl,
                        urlId: data.urlId,
                        requiredProjectId: data.requiredProjectId,
                        hidden: data.hidden || false,
                        createTime: data.createTime
                    }))
            });
            this.state.myProjectsData.forEach(item => {
                // 请求内容并且将文件内容转换为Uint8Array
                if (item.projectUrl) {
                    fetch(item.projectUrl)
                    .then(response => response.arrayBuffer())
                    .then(buffer => {
                        // this.props.onLoadingStarted(false);
                            let name = `${item.name}.py`
                            fs.write(
                                name,
                                new Uint8Array(buffer),
                                VersionAction.INCREMENT
                            );
                    })
                    .catch(e => {});
                }
                nameList.push(item.name)
            })
            this.props.setProjectNamesList(nameList)
            // localStorage.setItem('projectList', JSON.stringify(this.state.myProjectsData))
            // 如果是请求数据 请求同时自动向下移
            if (type === 'scrollDown') {
                this.scrollDown()
            }
        })
        .catch(error => {
            // 处理错误
            console.error(error);
            // this.handleRequestCatch(error);
        });
    }

    componentWillUnmount() {
        // 销毁监听事件防止内存泄漏
        window.removeEventListener('scroll', this.handleScroll, true);
    }

    // 请求:更新作品名称
    handleProjectNameUpdateRequest = name => {
        this.setState({
            isShowRenameInput: false
        });
        const {projectId} = this.state;
        new Promise((resolve, reject) => {
            requestUpdateProjectTitle(resolve, reject, projectId, name);
        })
            .then(() => {
                this.projectMap[projectId].name = name;
                // 如果是当前作品，更新当前作品名称
                if (this.props.mataProjectId === projectId) {
                    window.scratch.setProjectName(name);
                }
            })
            .catch(err => {
                this.handleRequestCatch(err);
            });
    };

    // 请求：删除某个作品
    handleDeleteProject = () => {
        const {projectId} = this.state;
        if (!projectId) return;
        // console.log("确认删除作品", projectId);
        new Promise((resolve, reject) => {
            requestDeleteProject(resolve, reject, projectId);
        })
            .then(() => {
                this.handleMyProjectsRequest('init');
                this.props.onSetMataProjectId(null);
            })
            .catch(error => {
                this.handleRequestCatch(error);
                // toast.error(error.msg || <FormattedMessage {...error} />);
            });
    };

    // 选中，
    handleSelect (id) {
        this.setState({projectId: id});
    }

    // 关闭模态
    handleClose () {
        this.props.onRequestClose();
    }

    // // 确认选中，打开对应作品
    handleConfirm (id) {
        // const {projectId: id} = this.state;
        if ((!id || typeof id !== 'number') && !this.state.projectId) return;
        const item = this.state.projectId ? this.projectMap[this.state.projectId] : this.projectMap[id];
        this.props.onItemSelected(item);
    }

    handleTagClick (tag) {
        if (this.state.playingItem === null) {
            this.setState({
                filterQuery: '',
                selectedTag: tag.toLowerCase()
            });
        } else {
            this.props.onItemMouseLeave(this.getFilteredData()[[this.state.playingItem]]);
            this.setState({
                filterQuery: '',
                playingItem: null,
                selectedTag: tag.toLowerCase()
            });
        }
    }

    handleMouseEnter (id) {
        // don't restart if mouse over already playing item
        if (this.props.onItemMouseEnter && this.state.playingItem !== id) {
            this.props.onItemMouseEnter(this.getFilteredData()[id]);
            this.setState({
                playingItem: id
            });
        }
    }

    handleMouseLeave (id) {
        if (this.props.onItemMouseLeave) {
            this.props.onItemMouseLeave(this.getFilteredData()[id]);
            this.setState({
                playingItem: null
            });
        }
    }

    handlePlayingEnd () {
        if (this.state.playingItem !== null) {
            this.setState({
                playingItem: null
            });
        }
    }

    handleFilterChange (event) {
        if (this.state.playingItem === null) {
            this.setState({
                filterQuery: event.target.value
            });
        } else {
            this.props.onItemMouseLeave(this.getFilteredData()[[this.state.playingItem]]);
            this.setState({
                filterQuery: event.target.value,
                playingItem: null
            });
        }
    }

    handleFilterClear () {
        this.setState({filterQuery: ''});
    }

    getFilteredData () {
        return this.state.myProjectsData;
    }

    scrollToTop () {
        this.filteredDataRef.scrollTop = 0;
    }

    setFilteredDataRef (ref) {
        this.filteredDataRef = ref;
    }

    render () {
        const listData = this.getFilteredData() || [];
        // 渲染项目列表
        const renderProjectList = listData.map((dataItem, index) => (
            <ProjectItem
                // 选中后的className
                className={this.state.projectId === dataItem.id ? "selected" : ''}
                collaborator={dataItem.collaborator}
                description={dataItem.description}
                disabled={dataItem.disabled}
                extensionId={dataItem.extensionId}
                featured={dataItem.featured}
                hidden={dataItem.hidden}
                iconMd5={dataItem.costumes ? dataItem.costumes[0].md5ext : dataItem.md5ext}
                iconRawURL={dataItem.rawURL}
                icons={dataItem.costumes}
                id={dataItem.id}
                insetIconURL={dataItem.insetIconURL}
                internetConnectionRequired={dataItem.internetConnectionRequired}
                isPlaying={this.state.playingItem === index}
                key={typeof dataItem.id === 'number' ? dataItem.id : dataItem.rawURL}
                name={dataItem.name}
                showPlayButton={this.props.showPlayButton}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
                handleConfirm={this.handleConfirm}
                onSelect={this.handleSelect}
                projectId={this.state.projectId}
                createTime={dataItem.createTime}
            />
        ));

        if (!this.state.loaded) {
            return (
                <div className="spinnerWrapper">
                    {/* <Spinner
                        large
                        level="primary"
                    /> */}
                </div>
            );
        }

        if (listData.length <= 0) {
            return (<Empty
                className="emptyContainer"
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                imageStyle={{height: '100px', width: '100px'}}
            />);
        }

        return (
            <ProjectGridContext.Provider
                value={{
                    // onRefresh: this.handleMyProjectsRequest,
                    onUpdateName: this.handleProjectNameUpdateRequest,
                    onDelete: this.handleDeleteProject
                }}
            >
                <div
                    className="myworkScrollGird"
                    ref={this.setFilteredDataRef}
                >
                    {renderProjectList}
                    <div ref={this.bottomRef} />
                </div>
                {/* footer */}
                <div className="modalFooter">
                    {/* <div
                        className={styles.modalCancel}
                        onClick={this.handleClose}
                    >
                        {cancel}
                    </div> */}
                    <div
                        className="modalConfirm"
                        onClick={this.handleConfirm}
                    >
                        {ok}
                        {/* 确定 */}
                    </div>
                </div>
            </ProjectGridContext.Provider>
        );
    }
}

GridComponent.propTypes = {
    id: PropTypes.string.isRequired,
    // intl: intlShape.isRequired,
    onItemMouseEnter: PropTypes.func,
    onItemMouseLeave: PropTypes.func,
    onItemSelected: PropTypes.func, // 某项被选中
    onRequestClose: PropTypes.func,
    // onRefresh: PropTypes.func, //刷新列表
    setStopHandler: PropTypes.func,
    showPlayButton: PropTypes.bool,
    onSetMataProjectId: PropTypes.func,
    mataProjectId: PropTypes.string,
    onUserLoggedOut: PropTypes.func,
    onLoadingFinished: PropTypes.func
};

GridComponent.defaultProps = {
    showPlayButton: false
};
const mapStateToProps = state => {
    return {
        projectNamesList: state.projectStore.projectNamesList
    };
};
const mapDispatchToProps = dispatch => ({
    setProjectNamesList: (list) => dispatch(setProjectNamesList(list))
});

// export default injectIntl(GridComponent);
// export default GridComponent;
export default compose(
    connect(mapStateToProps, mapDispatchToProps)
)(GridComponent);
